import React from "react"
import { ThemeProvider } from "styled-components"
import { theme } from "./utils/styling"
import GlobalStyle from "./components/atoms/GlobalStyles"
import CanvasHolder from "./components/organisms/CanvasHolder"
import CanvasInner from "./components/organisms/CanvasInner"
import Labels from "./components/organisms/Labels"

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <CanvasHolder>
        <CanvasInner />
      </CanvasHolder>
      <Labels />
    </ThemeProvider>
  )
}

export default App
